import { maybeRunTurnstile } from '~/helpers/turnstile-human';

// See helpers/turnstile-human.js for architecture and flow.
export default () => {
  window.onNuxtReady(() => {
    maybeRunTurnstile();
  });
};
